import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MoneyStackIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 7C8.82843 7 9.5 6.32843 9.5 5.5C9.5 4.67157 8.82843 4 8 4C7.17157 4 6.5 4.67157 6.5 5.5C6.5 6.32843 7.17157 7 8 7Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.25 1C1.55964 1 1 1.55964 1 2.25V8.75C1 9.41246 1.51533 9.95456 2.16698 9.99729C2.17772 9.99907 2.18875 10 2.2 10H13.8C13.8112 10 13.8223 9.99907 13.833 9.99729C14.4847 9.95456 15 9.41246 15 8.75V2.25C15 1.55964 14.4404 1 13.75 1H2.25ZM2.5 7.03023C3.24528 7.16713 3.83287 7.75472 3.96977 8.5H12.0302C12.1671 7.75472 12.7547 7.16713 13.5 7.03023V3.96977C12.7547 3.83287 12.1671 3.24528 12.0302 2.5H3.96977C3.83287 3.24528 3.24528 3.83287 2.5 3.96977V7.03023Z"
		></path>
		<path
			fill="currentColor"
			d="M1 11.5V11H15V11.5C15 12.0523 14.5523 12.5 14 12.5H2C1.44772 12.5 1 12.0523 1 11.5Z"
		></path>
		<path
			fill="currentColor"
			d="M1 14V13.5H15V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14Z"
		></path>
	</svg>
))
